import React from "react";

const ProductRow = ({
  product,
  index,
  setModalData,
  setShowProductDeleteModal,
}) => {
  const {
    product_image,
    product_name,
    product_price,
    product_brand_slug,
    stock,
  } = product;

  const handleShowModel = () => {
    setModalData(product);
    setShowProductDeleteModal(true);
  };
  return (
    <tr>
      <th>{index + 1}</th>
      <td>
        <div class="avatar">
          <div class="w-24 mask mask-squircle">
            <img src={product_image} alt="brand_image" />
          </div>
        </div>
      </td>
      <td>{product_name}</td>
      <td>{stock}</td>
      <td>{product_price}</td>
      <td>{product_brand_slug}</td>
      <td>
        <label
          onClick={handleShowModel}
          for="productDeleteModel"
          className="btn btn-sm btn-secondary"
        >
          Delete
        </label>
      </td>
    </tr>
  );
};

export default ProductRow;
